// @flow
import PrimaryPalette from '../../../colors';
import Tokens from '../../../tokens';

const Theme = {
  list: {
    backgroundColor: PrimaryPalette.white,
    borderColor: PrimaryPalette.mediumGrey,
  },
  listItem: {
    highlightedColor: Tokens.colors.hover,
    selectedColor: Tokens.colors.selected,
    errorColor: Tokens.colors.error,
  },
};

export default Theme;
